<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>仓库地址列表</h3>
                </el-col>
                <el-col :span="2">
                    <el-button type="info" @click="handleAdd">新建</el-button>
                </el-col>
            </el-row>
        </div>
        <!-- <el-form :inline="true" ref="formInline" :model="formInline" class="demo-form-inline">
            <el-form-item label="手机号" prop="mobile">
                <el-input v-model="formInline.mobile" placeholder="手机号"></el-input>
            </el-form-item>
    
            <el-form-item>
                <el-button type="primary" @click="Search">查询</el-button>
                <el-button @click="resetForm('formInline')">重置</el-button>
            </el-form-item>
        </el-form> -->
    
        <el-table :data="fetchList">
            <el-table-column prop="storageNo" label="编号">
            </el-table-column>
            <el-table-column prop="storageName" label="仓库名称">
            </el-table-column>
            <el-table-column prop="recipient" label="收件人">
            </el-table-column>
            <el-table-column inline-template :context="_self" label="提交时间">
                <span v-if="row.created">{{ new Date(row.created).getFullYear()+'-'+(new Date(row.created).getMonth()+1)+'-'+new Date(row.created).getDate()+' '+new Date(row.created).getHours()+':'+new Date(row.created).getMinutes()+':'+new Date(row.created).getSeconds()}} </span>
            </el-table-column>
            <el-table-column prop="deviceCount" label="拥有的设备数量">
            </el-table-column>
            <el-table-column inline-template :context="_self" width="200" label="操作">
                <span>
                    <el-button @click="handleView($index, row)" type="text" size="small">查看</el-button>
                    <el-button @click="handleEdit($index, row)" type="text" size="small">编辑</el-button>
                </span>
            </el-table-column>
        </el-table>
    
        <el-dialog title="查看仓库信息" :visible.sync="dialogFormVisible">
            <el-form :model="form">
                <el-form-item label="仓库名称：" label-width="150px">
                    <span>{{form.storageName}}</span>
                </el-form-item>
                <el-form-item label="仓库编号：" label-width="150px">
                    <span>{{form.storageNo}}</span>
                </el-form-item>
                <el-form-item label="收货人：" label-width="150px">
                    <span>{{form.recipient}}</span>
                </el-form-item>
                <el-form-item label="手机号：" label-width="150px">
                    <span>{{form.mobile}}</span>
                </el-form-item>
                <el-form-item label="详细地址：" label-width="150px">
                    <span>{{form.fullAddress}}</span>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogFormVisible = false">关闭</el-button>
            </div>
        </el-dialog>
    
        <el-dialog title="新建仓库地址" :visible.sync="dialogNewVisible">
            <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                <el-form-item label="仓库名称" label-width="150px" prop="storageName">
                    <el-input v-model="newForm.storageName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="仓库编号" label-width="150px" prop="storageNo">
                    <el-input v-model="newForm.storageNo" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收货人" label-width="150px" prop="recipient">
                    <el-input v-model="newForm.recipient" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="150px" prop="mobile">
                    <el-input v-model="newForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="省市区选择" label-width="150px">
                    <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" label-width="150px" prop="address">
                    <el-input v-model="newForm.address" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogNewVisible = false">取 消</el-button>
                <el-button type="primary" @click="addNewOne">确 定</el-button>
            </div>
        </el-dialog>
    
    
        <el-dialog title="编辑仓库地址" :visible.sync="dialogEditVisible">
            <el-form :model="newForm" ref="newForm" :rules="addStorageRules">
                <el-form-item label="仓库名称" label-width="150px" prop="storageName">
                    <el-input v-model="newForm.storageName" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="仓库编号" label-width="150px" prop="storageNo">
                    <el-input v-model="newForm.storageNo" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="收货人" label-width="150px" prop="recipient">
                    <el-input v-model="newForm.recipient" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="手机号" label-width="150px" prop="mobile">
                    <el-input v-model="newForm.mobile" auto-complete="off"></el-input>
                </el-form-item>
                <el-form-item label="省市区选择" label-width="150px">
                    <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
                    </el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" label-width="150px" prop="fullAddress">
                    <el-input v-model="newForm.fullAddress" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogEditVisible = false">取 消</el-button>
                <el-button type="primary" @click="editStorage">确 定</el-button>
            </div>
        </el-dialog>
    
    </div>
</template>

<script>
    import {
        getStoragesList,
        filterStorages,
        postStorages,
        deleteStorages,
        patchStorages,
        getStorageCount
    } from '../../api/version'
    import {
        provinceAndCityData,
        regionData,
        provinceAndCityDataPlus,
        regionDataPlus,
        CodeToText,
        TextToCode
    } from 'element-china-area-data'
    
    export default {
        data() {
            return {
                fetchList: [],
                formInline: {
                    mobile: ''
                },
                dialogFormVisible: false,
                dialogNewVisible: false,
                dialogEditVisible: false,
                form: {
                    fullAddress: '',
                    mobile: '',
                    recipient: '',
                    id: '',
                    storageName: '',
                },
                addStorageRules: {
                    address: [{
                        required: true,
                        message: '请填写详细地址',
                        trigger: 'blur'
                    }],
                    storageName: [{
                        required: true,
                        message: '请填写仓库名称',
                        trigger: 'blur'
                    }],
                    mobile: [{
                        required: true,
                        message: '请填写手机号',
                        trigger: 'blur'
                    }],
                    recipient: [{
                        required: true,
                        message: '请填写收货人',
                        trigger: 'blur'
                    }],
                    storageNo: [{
                        required: true,
                        message: '请填写编号',
                        trigger: 'blur'
                    }],
                },
                newForm: {
                    fullAddress: '',
                    address: '',
                    mobile: '',
                    recipient: '',
                    storageName: '',
                    storageNo: '',
                    province: '',
                    city: '',
                    district: ''
                },
                options: regionData,
                selectedOptions: []
            }
        },
    
        created() {
            getStoragesList(sessionStorage.userId).then(res => {
                this.fetchList = res.data
                this.fetchList.forEach( (item,index) => {
                     this.fetchList[index].deviceCount = 0
                    getStorageCount(sessionStorage.userId, JSON.stringify({
                        
                            'storageId': item.id,
                            'isOnline': true
                        
                    })).then( res => {
                        if(res.data) {
                            this.fetchList[index].deviceCount = res.data.count
                            this.fetchList = JSON.parse(JSON.stringify(this.fetchList))
                        }
                    })
                })
            })
    
        },
    
        methods: {
            handleView(index, row) {
                //查看
                this.dialogFormVisible = true
                this.form = row
            },
    
            handleChange(value) {
                console.log(this.selectedOptions)
                value.forEach((item, index) => {
                    if (index === 0) {
                        this.newForm.province = CodeToText[item]
                    } else if (index === 1) {
                        this.newForm.city = CodeToText[item]
                    } else {
                        this.newForm.district = CodeToText[item]
                    }
                    console.log(CodeToText[item])
                })
            },
    
            handleDelete(index, row) {
                this.$confirm('此操作将永久删除该仓库, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
    
                    deleteStorages(sessionStorage.userId, row.id).then(res => {
                        if (res.data) {
                            this.$message({
                                message: '成功删除',
                                type: 'success'
                            });
                            this.fetchList.splice(index, 1)
                        }
                    }, err => {
                        this.$message.error('删除失败')
                    })
    
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            resetForm(formName) {
                this.formInline.dayEnd = ''
                this.$refs[formName].resetFields();
            },
            handleAdd() {
                //添加仓库弹框
                this.dialogNewVisible = true
                this.newForm = {}
            },
            handleEdit(index, row) {
                //编辑仓库弹框
                this.dialogEditVisible = true
                this.newForm = JSON.parse(JSON.stringify(row))
                console.log(this.newForm)
                if (this.newForm.province === '上海市' || this.newForm.province === '重庆市' || this.newForm.province === '北京市' || this.newForm.province === '天津市') {
                    this.newForm.city = '市辖区'
                }
                this.selectedOptions = []
                this.selectedOptions[0] = TextToCode[this.newForm.province].code
                this.selectedOptions[1] = TextToCode[this.newForm.province][this.newForm.city].code
                this.selectedOptions[2] = TextToCode[this.newForm.province][this.newForm.city][this.newForm.district].code
            },
            editStorage() {
                //编辑上传
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        if (!this.newForm.province) {
                            this.$message.error('请选择地区');
                        } else {
                            this.newForm.fullAddress = `${this.newForm.fullAddress}`
                            let data = JSON.parse(JSON.stringify(this.newForm))
                            delete data.address
                            if (data.city === '市辖区') {
                                data.city = data.province
                            }
                            this.fetchList.forEach((item, index) => {
                                if (item.id === data.id) {
                                    this.fetchList[index] = JSON.parse(JSON.stringify(this.newForm))
                                }
                            })
                            delete data.id
                            patchStorages(sessionStorage.userId, this.newForm.id, data).then(res => {
                                if (res.data) {
                                    this.$message({
                                        message: '成功更新仓库信息',
                                        type: 'success'
                                    });
                                    this.dialogEditVisible = false
                                    this.newForm = {
                                        fullAddress: '',
                                        address: '',
                                        mobile: '',
                                        recipient: '',
                                        storageName: '',
                                        storageNo: '',
                                        province: '',
                                        city: '',
                                        district: ''
                                    }
                                    this.selectedOptions = []
                                }
    
                            }, err => {
                                this.$message.error('更新失败');
                            })
                        }
                    }
                })
            },
            addNewOne() {
                //确认添加仓库
                console.log(this.newForm)
                this.$refs['newForm'].validate((valid) => {
                    if (valid) {
                        if (!this.newForm.province) {
                            this.$message.error('请选择地区');
                        } else {
                            this.newForm.fullAddress = `${this.newForm.province}${this.newForm.city}${this.newForm.district}${this.newForm.address}`
                            let data = JSON.parse(JSON.stringify(this.newForm))
                            delete data.address
                            if (data.city === '市辖区') {
                                data.city = data.province
                            }
                            
                            postStorages(sessionStorage.userId, data).then(res => {
                                if (res.data) {
                                    this.$message({
                                        message: '成功创建仓库',
                                        type: 'success'
                                    });
                                    res.data.deviceCount = 0
                                    this.fetchList.push(res.data)
                                    this.dialogNewVisible = false
                                    this.newForm = {
                                        fullAddress: '',
                                        address: '',
                                        mobile: '',
                                        recipient: '',
                                        storageName: '',
                                        storageNo: '',
                                        province: '',
                                        city: '',
                                        district: ''
                                    }
                                    this.selectedOptions = []
                                }
    
                            }, err => {
                                this.$message.error('创建失败');
                            })
                        }
                    }
                })
            },
            Search() {
                //搜索
    
                let search = {
                    'where': {
                        mobile: this.formInline.mobile
                    }
                }
                console.log(JSON.stringify(search))
                filterStorages(sessionStorage.userId, JSON.stringify(search)).then(res => {
                    this.fetchList = res.data
                }, err => {
                    console.log(err)
                })
            },
    
    
        }
    }
</script>

<style>
    .user-pic {
        width: 50px;
        height: 50px;
        margin-top: 10px;
    }
    
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .page-footer {
        margin-top: 60px;
        text-align: center;
    }
</style>




// WEBPACK FOOTER //
// StorageList.vue?6a9e5e90